/**
 * URL参数转换成对象
 * @param {string} url
 */
export function getQuery(url) {
  let query = decodeURIComponent(decodeURIComponent(decodeURIComponent(url || location.search)));
  let rst = {};

  try {
    if (query) {
      const qs = query.split('#');

      if (qs && qs[0]) {
        query = qs[0];
      } else {
        query = null;
      }
    }
  } catch (error) {
    query = null;
  }

  if (query) {
    query = query.split('?');

    if (query.length < 2) {
      return rst;
    }

    query = query[1].split('&');
    if (query && query.length > 0) {
      $.each(query, function(key, val) {
        val = val.split('=');
        if (val && val.length > 1) {
          rst[val.shift()] = val.join('=');
        }
      });
    }
  }

  return rst;
}

export function getQueryExt($route, key) {
  const qs = getQuery();

  if ($route && $route.query && typeof $route.query[key] !== 'undefined') {
    return $route.query[key];
  } else if (typeof qs[key] !== 'undefined') {
    return qs[key];
  }

  return '';
}

/**
 * 给URL添加参数
 * @param {url} url
 * @param {对象} data
 */
export function add(url, data) {
  if (!url || !data) {
    return url;
  }

  var oldParam = getQuery(url);

  if (oldParam && $.type(oldParam) === 'object') {
    data = $.extend({}, oldParam, data);
    url = url.split('?')[0];
  }

  data = $.param(data);

  if (data) {
    if (url.indexOf('?') > -1) {
      url += '&' + data;
    } else {
      url += '?' + data;
    }
  }

  return url;
}

/**
 * 给URL加时间挫
 * @param {url} url
 * @param {参数} data
 */
export function clearCache(url, data) {
  data = data || {};
  data.t = new Date().getTime();
  return add(url, data);
}

/**
 * 延时跳转
 * @param {url} url
 * @param {参数} opts
 */
export function navigation(url, opts = {}, delay) {
  delay = delay || 200;

  url = add(url, opts);

  const stt = setTimeout(() => {
    clearTimeout(stt);
    // alert(url);
    window.location.href = url;
  }, delay);
}

export default {
  getQuery,
  add,
  clearCache,
  getQueryExt,
  navigation
};
